module.exports = __webpack_public_path__ + "img/85.10.pH.73cbbd66.png";